import { Box, IconButton, useTheme,Typography ,Autocomplete,Options,TextField,GroupHeader,GroupItems} from "@mui/material";
import { useContext, useState, useEffect, useCallback  } from "react";
import { ColorModeContext, tokens } from "../../theme";
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { logout } from "../../slices/auth";
import { Link } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import Login from '@mui/icons-material/Login';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import Popover from '@mui/material/Popover';
import ProfileAvatar from "../user/ProfileAvatar";
import { padding } from "@mui/system";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'; 



const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);

  const { user: currentUser } = useSelector((state) => state.auth);
  const { isLoggedIn } = useSelector((state) => state.auth);


  const dispatch = useDispatch();

  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);


  const [anchorElProfile, setAnchorElProfile] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  const [options, setOptions] = useState(['Collection']);

  useEffect(() => {

    const collectionOptions = currentUser?.collections.map((option) => {
      const parent = option.parentCollection;
  
      let parentName = "";
  
      if (parent != "") {
        parentName = currentUser.collections.find(col => { return col.id === parent})?.name || 'No Access'
      }
  
      return {
        parentName,
        ...option,
      };
    });

    if (collectionOptions){

      setOptions(collectionOptions);

      let userCollection = currentUser?.user.collection
      let foundCollection = currentUser?.collections.find(col => { return col.id === userCollection})
  
      setInputValue(foundCollection)
      setValue(foundCollection)

    }

  },[currentUser])

  const [value, setValue] = React.useState(options[0]);
  const [inputValue, setInputValue] = React.useState('');

  
 

//---------------end--------------------


  return (

    
    <Box display="flex" justifyContent="space-between" p={2}>

      {/* SEARCH BAR */}
      <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
      >
        {/* <TextField size="small" placeholder="Search"/>
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton> */}
        
      </Box>

      {/* ICONS */}
      <Box display="flex">

      {isLoggedIn &&
        
        <Autocomplete
          //multiple
          size="small"
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}

          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}

          isOptionEqualToValue={(option, value) =>  {
            return option.id === value.id}}

          disableClearable
          id="collection-list"
          options={options.sort((a, b) => -b.name.localeCompare(a.name))}
          //groupBy={(option) => option.parentName}
          getOptionLabel={(option) => option.name || ""}
          sx={{ width: 200 , mr: 2}}
          renderInput={(params) => <TextField {...params}  />}

        />
      }

        <IconButton onClick={colorMode.toggleColorMode} >
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton >
          <NotificationsOutlinedIcon />
        </IconButton>
        
          <IconButton
            onClick={handleClick}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            sx={{ objectFit: "cover" }}
          >
            {isLoggedIn ? 
              <>
              <ProfileAvatar user = {currentUser.user} size="24"/>

              <Box textAlign="left" >
                <Typography
                  fontWeight="bold"
                  fontSize="0.85rem"
                  sx={{ color: theme.palette.secondary[100], lineHeight: "24px" , gap:"1rem"}}
                >
                  {currentUser.user.username}
                </Typography>

              </Box>
              </>
            :
              <PersonOutlinedIcon/>
}

              

              <ArrowDropDownOutlinedIcon
                sx={{ color: theme.palette.secondary[300], fontSize: "25px" }}
              />


          </IconButton>

      </Box>
      

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >

{isLoggedIn && (
  <div>
        <MenuItem component={Link} to={'./profile'} >
          <ProfileAvatar user = {currentUser.user} size="24"/>
          Profile
        </MenuItem>

        <MenuItem component={Link} to={"./user/" + currentUser.user.username} >
        <ListItemIcon> 
            <ManageAccountsIcon fontSize="small" />
          </ListItemIcon>
          My Account
        </MenuItem>

        <Divider />
        <MenuItem>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>
        
        </div>
)}

        {isLoggedIn ? (
        <MenuItem onClick={logOut}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
          
        </MenuItem>

        )
        :(
          <div>
          <MenuItem component={Link} to="./register" > 
            <ListItemIcon>
              <PersonAdd fontSize="small" />
            </ListItemIcon>
            
            New Account
        </MenuItem>

          <MenuItem component={Link} to="./login" > 
            <ListItemIcon>
              <Login fontSize="small" />
            </ListItemIcon>
            
            Login
        </MenuItem>
        </div>
        )}
      </Menu>
      

      </Box>
  );
};

export default Topbar;
